<template>
    <div class="editor">
        <el-tiptap
            :showMenubar="false"
            :charCounterCount="false"
            :placeholder="placeholder"
            v-model="content"
            :extensions="prepareExtensions()"
            @onBlur="onBlur"
        />
    </div>
</template>

<script>
import EditorMixin from '../../system/mixins/editor.mixin';

export default {
    mixins: [EditorMixin],
}
</script>
